import { render, staticRenderFns } from "./NotesDeFrais.vue?vue&type=template&id=0befb50c&scoped=true"
import script from "./NotesDeFrais.vue?vue&type=script&lang=js"
export * from "./NotesDeFrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befb50c",
  null
  
)

export default component.exports